export const GENERIC_GLOBAL = 'global.generic';
export const PDP_PLCC_LABELS = 'Browse.PDP';

export const globalGenericLabels = {
  global: {
    generic: {
      lbl_learnMore: 'Learn More',
      lbl_creditCard: 'Credit Card',
    },
  },
};

export const pdpPLCCBannerLabelsData = {
  Browse: {
    PDP: {
      plccc_banner_text_pdp: 'SAVE #plccOfferPercentage#% when you open and use a',
      lbl_PLCC_reward_multiclr:
        '<span style="color:#e86726;font-weight:900">MY</span> <span style="color:#00a7e0;font-weight:900">PLACE</span> <span style="color:#e2499b;font-weight:900">REWARDS</span>',
      lbl_PLCC_reward_brand_theme:
        '<span style="color:#232A54;font-weight:900">MY PLACE REWARDS</span>',
      lbl_banner_pdp_plcc_rewards_label:
        'Earn <span style="color:#00a7e0">2X</span> Points when you checkout with your',
      lbl_banner_pdp_mpr_rewards_label:
        'Earn <span style="color:#e86726">2X</span> Points Everyday with',
      lbl_banner_pdp_guest_rewards_label1: 'Get Rewarded!',
      lbl_banner_pdp_guest_rewards_label2: '$1 SPENT = 1 POINT  |  100 POINTS = $5 REWARD',
    },
  },
};

export const pdpSubLabels = {
  ProductDetailPage: {
    PDP_Sub: {
      lbl_plcc_banner_discription: 'on your first purchase when you',
      lbl_plcc_banner_my: 'MY',
      lbl_plcc_banner_place: 'PLACE',
      lbl_plcc_banner_rewards: 'REWARDS',
      lbl_plcc_banner_discription_open: 'open & use the',
      lbl_plcc_banner_pay: 'Pay',
      lbl_plcc_banner_desc: 'for this item when you',
    },
  },
};
